import { Service } from '@/modules/Service/types'
import React, { useEffect } from 'react'
import { ServiceDomainMetadata } from '../types'
import { Alert, GridHookForm } from 'vnetwork-ui'
import { FormProvider, Path, useForm } from 'react-hook-form'
import Metadata from '@/components/Domain/VNNIC/DomainFormFields/Metadata'
import DomainStepsForm from '@/components/Domain/VNNIC/DomainStepsForm'
import { updateServiceMetadata } from '@/modules/Service/services'
import { useTranslation } from 'react-i18next'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
interface DomainVNNICSettingProps {
    service: Service
    metadata?: ServiceDomainMetadata
    refetch?: Function
}

const Setting: React.FC<DomainVNNICSettingProps> = ({
    service,
    metadata,
    refetch,
}) => {
    const formControl = useForm({
        defaultValues: {
            service_domain_metadata: metadata,
        },
    })

    const { t } = useTranslation()

    const updateMetadataMutation = useMutationWithHandler(
        {
            mutationFn: updateServiceMetadata,
        },
        {
            successMessage: t('update-metadata-success'),
            reactQueryKeys: QUERY_KEYS.SERVICES,
            onSuccess: () => {
                refetch?.()
            },
        }
    )

    const rootName = `service_domain_metadata.metadata` as Path<Service>

    useEffect(() => {
        formControl.reset({
            service_domain_metadata: metadata,
        })
    }, [metadata])

    return (
        <FormProvider {...formControl}>
            <div className="bg-white rounded-lg p-4 mt-2">
                {service?.service_creatable_uuid && (
                    <Alert variant="info" className="mb-4">
                        {t('warning-disable-update-domain')}
                    </Alert>
                )}
                <GridHookForm
                    // subForm
                    actions={[
                        {
                            title: 'Lưu',
                            type: 'submit',
                            variant: 'contained',
                            loading: updateMetadataMutation.isPending,
                            disabled:
                                updateMetadataMutation.isPending ||
                                !!service?.service_creatable_uuid ||
                                formControl?.formState?.isDirty,
                        },
                    ]}
                    onSubmit={(data) => {
                        updateMetadataMutation.mutate({
                            serviceID: service?.service_id,
                            metadata: data.service_domain_metadata?.metadata,
                        })
                    }}
                    data={[
                        {
                            renderEditComponent: () => {
                                return (
                                    <Metadata
                                        isAddons
                                        isDNS
                                        // index={index}
                                        rootName={rootName}
                                    />
                                )
                            },
                            className: 'col-span-2',
                        },
                        {
                            renderEditComponent: () => {
                                return <DomainStepsForm rootName={rootName} />
                            },
                            className: 'col-span-2',
                        },
                    ]}
                    formControl={formControl}
                />
            </div>
        </FormProvider>
    )
}

export default Setting
